/** @format */

import { gql } from '@apollo/client';
import { Campaign } from '../types';

export const GET_CAMPAIGNS_BY_OFFICE = gql`
  query campaignByOffice($officeId: String) {
    campaignsByOffice(officeId: $officeId) {
      vendorName
      _id
      buffer
      cost
      queueId
    }
  }
`;

export const UPDATE_CAMPAIGN = gql`
  mutation UpdateCampaign($id: String!, $input: UpdateCampaignInput!) {
    updateCampaign(_id: $id, input: $input) {
      _id
      buffer
      cost
      createdAt
      globalId
      queueId
      vendorName
      officeId
    }
  }
`;

export interface CampaignsByOfficeData {
  campaignsByOffice: Campaign[];
}

export interface CampaignsByOfficeVariables {
  officeId?: string;
}

export interface UpdateCampaignInput {
  vendorName?: string;
  globalId?: string;
  globalName?: string;
  cost?: number;
  buffer?: number;
}

export interface UpdateCampaignData {
  updateCampaign: Campaign;
}

export interface UpdateCampaignVariables {
  id: string;
  input: UpdateCampaignInput;
}
